/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/bonz/modules/utils.js
 * In commit: de125d9c0dbfa23a5f12f049c70f4e9e185a6932
 * For ticket: GRINS-1507
 */

import { Fandango as Fandango_context } from '@grins/fd-modules/splits/require-core';

import {
  Fandango_cookie as cookie,
  Fandango_debugLog as debugLog,
  Fandango_queryUtil as Fandango_queryUtil_getParam_setParam,
  Fandango_sanitizer as sanitizer,
  Fandango_xhr as xhr,
  fd_url_manager as links
} from '@grins/fd-modules/splits/onering-global';

const { getParam, setParam } = Fandango_queryUtil_getParam_setParam;

// @ts-ignore
const { context: { device } } = Fandango_context;

const QueryParams = {
  FROM: 'from',
  SOURCE: 'source',
  ACTION: 'action',
  ID: 'id',
};
const AddActions = Object.freeze({
  MOVIE: 'addmovie',
  THEATER: 'addtheater',
});

const Routes = {
  PURCHASE_RECORD: 'purchaserecord',
};

const CookieNames = {
  DEVICE_TYPE: 'devicetype',
};

function addFavorite() {
  const id = sanitizer.id(getParam(QueryParams.ID));
  const action = getParam(QueryParams.ACTION);
  if (!id || !(action === AddActions.THEATER || action === AddActions.MOVIE)) {
    return;
  }
  xhr.ajax({
    url: links.snapiFavorites({
      type: action === AddActions.THEATER ? 'theater' : 'movie',
      id,
    }),
    method: 'POST',
    data: {
      id,
      isFavorite: false,
    }
  })
    ?.done(() => debugLog.info('bonz/modules/utils', action, 'favorited success'))
    .fail((err: unknown) => debugLog.error('bonz/modules/utils', action, 'favorited failed', err));
}
function getDestinationURI() {
  const from = decodeURIComponent(sanitizer.url(getParam(QueryParams.FROM)) || '');
  let uri = from || links.dashboard();
  const source = sanitizer.text(getParam(QueryParams.SOURCE));
  if (source) {
    const [path, queryParams] = uri.split('?');
    uri = `${path}?${setParam(QueryParams.SOURCE, source, queryParams || '')}`;
  }
  return uri;
}

function saveAuthenticationToApp(email: string, password: string, action: 'join' | 'signin') {
  if (device.isWebView) {
    const url = `fandango://?op=${Routes.PURCHASE_RECORD}&email=${email}&password=${password}&action=${action}`;
    const isIosApp: boolean = cookie.get(CookieNames.DEVICE_TYPE)?.toLowerCase().includes('ios') ?? false;
    window.open(url, isIosApp ? '_self' : undefined);
  }
}


export default {
  addFavorite,
  getDestinationURI,
  saveAuthenticationToApp,
};
